import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postFileUpload,
} from "./helpers/http-handler";

export const clientCreateVendor = (payload: object) =>
  post(`${config.API_URL}/vendors`, payload);

export const clientGetSpecificVendor = (id: string) =>
  get(`${config.API_URL}/vendors/${id}`);

export const clientUpdateSpecificVendor = (id: string, payload: object) =>
  patch(`${config.API_URL}/vendors/${id}`, payload);
